import { adminHttpClient } from '../../commons/adminHttpClient'

export type PersonalDetailsRequest = {
  personalEmail: string
  phoneNumber: string
  receiveSms: boolean
}

const updatePerksPersonalDetails = (request: PersonalDetailsRequest): Promise<any> => {
  return adminHttpClient.put('/EESignup/Perks/PersonalDetails', request)
}

export default updatePerksPersonalDetails
